import React, { useState } from "react";
import TableCell from "@material-ui/core/TableCell";
import useAlertDialog from "../../../../hooks/useAlertDialog";
import { AlertType } from "../../../../hooks/common/useAttachAlertDialog";
import { TableRow } from "@material-ui/core";
import { OrderStatusLabelMap, PriceDetail } from "../../../../../models/Order";
import moment from "moment";
import {
	BookingTableBodyButton,
	BookingTableBodyDate,
	BookingTableBodyStauts,
	TableCellFloatLeft,
	TableCellFloatLeftInner,
	TableCellFloatLeftInnerUser,
} from "../../styled/DesStyled";
import useCancelOrder from "../../hook/CancelOrder";
import useLoadedUser from "../../../../hooks/auth/useLoadedUser";
import { UserRole } from "../../../../../models/User";
import { formatOrderCalendarDate } from "../../../../../utils/orderCalendarDate";

export default function BookingTableBodyPartner(props: {
	val: PriceDetail;
	reload: () => void;
	setIsDialogLoginOpen: (val: boolean) => void;
	setOrderId: (val: number) => void;
}) {
	const [load, setLoad] = useState(false);
	const { user } = useLoadedUser();
	const [anchorEl, setAnchorEl] = useState(null);
	const { openAlertDialog } = useAlertDialog();
	const { doCancelOrder } = useCancelOrder({ reload: props.reload, user: user, setLoad: setLoad });

	const handleUpdateStatusStaff = async (id: number) => {
		openAlertDialog?.(
			AlertType.Confirm,
			"You definitely want to cancel your order?",
			() => {},
			() => doCancelOrder(id || 0),
			undefined,
			{
				declineText: "Cancel",
				acceptText: "Confirm",
			}
		);
	};

	const handleUpdateOrder = async (id: number) => {
		props.setIsDialogLoginOpen(true);
		props.setOrderId(id);
	};

	return (
		<>
			<TableRow>
				<TableCell align="center">{props.val.id}</TableCell>
				<TableCell align="center">
					<TableCellFloatLeft>
						<TableCellFloatLeftInnerUser>Name:</TableCellFloatLeftInnerUser> {props.val.customer?.fullName}
					</TableCellFloatLeft>
					<TableCellFloatLeft>
						<TableCellFloatLeftInnerUser>Email:</TableCellFloatLeftInnerUser>
						{props.val.customer?.email}
					</TableCellFloatLeft>
					<TableCellFloatLeft>
						<TableCellFloatLeftInnerUser>Phone:</TableCellFloatLeftInnerUser>{" "}
						{props.val.customer?.phone || "--"}
					</TableCellFloatLeft>
				</TableCell>
				<TableCell align="center">{props.val.quantity}</TableCell>
				<TableCell align="center">{Math.round((props.val.totalMoney||0) * 100) / 100} USD</TableCell>
				<TableCell align="center">
					<BookingTableBodyDate>
						{
							props.val.timeInString
								? formatOrderCalendarDate(props.val.timeInString)
								: ((props.val.timeIn && formatOrderCalendarDate(props.val?.timeIn)) || "")
						}
					</BookingTableBodyDate>
					<br />
					<BookingTableBodyDate>
						{
							props.val.timeOutString
								? formatOrderCalendarDate(props.val.timeOutString)
								: ((props.val.timeOut && formatOrderCalendarDate(props.val?.timeOut)) || "")
						}
					</BookingTableBodyDate>
				</TableCell>
				<TableCell align="center">
					<BookingTableBodyStauts status={props.val?.status}>
						{" "}
						{OrderStatusLabelMap.get(props.val?.status || 0)}
					</BookingTableBodyStauts>
				</TableCell>
				<TableCell align="center">
					<BookingTableBodyDate>
						{(props.val.createdAt && moment(props.val?.createdAt).format("HH:mm DD-MM-YYYY")) || ""}
					</BookingTableBodyDate>
				</TableCell>

				<TableCell align="center">
					{user?.role != UserRole.Partner && (
						<>
							<BookingTableBodyButton
								loading={load}
								status={props.val?.status}
								onClick={() => handleUpdateStatusStaff(props.val.id || 0)}>
								{load ? "Loading ..." : "Cancel"}
							</BookingTableBodyButton>
							{user?.role == UserRole.Admin && (
								<BookingTableBodyButton
									status={1}
									onClick={() => handleUpdateOrder(props.val.id || 0)}>
									Edit
								</BookingTableBodyButton>
							)}
						</>
					)}
				</TableCell>
			</TableRow>
		</>
	);
}
